import { Component, OnInit, ViewContainerRef, OnDestroy, ViewChild } from '@angular/core';
import { TdDataTableService, TdDataTableSortingOrder, ITdDataTableSortChangeEvent, ITdDataTableColumn, TdDialogService, TdLoadingService, TdSearchBoxComponent } from '@covalent/core';
import { IPageChangeEvent } from '@covalent/core';
import { Product } from '../product';
import { ProductService } from '../product.service';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';
import { SettingsService } from '../../../../shared/services/settings.service';
import { ExportService } from '../../../../shared/services/export.service';
import { AuthenticationService } from '../../../../shared/services/authentication.service';
import { SupplierService } from '../../suppliers/supplier.service';
import { Utils } from '../../../../shared/utils';

@Component({
  selector: 'app-purchasing-products-list',
  templateUrl: './purchasing-products-list.component.html',
  styleUrls: ['./purchasing-products-list.component.scss'],
})

export class PurchasingProductsListComponent implements OnInit, OnDestroy {
  @ViewChild('searchBox') _searchBox: TdSearchBoxComponent;

  data: Product[];
  subscription: Subscription = new Subscription();
  allFabricTypes$: Observable<string[]>;
  allSuppliers$: Observable<{ id: number, name: string }[]>;

  columns: ITdDataTableColumn[] = [
    { name: 'id', label: 'Code', tooltip: 'some tooltip example' },
    { name: 'collection_name', label: 'Mystic Collection' },
    { name: 'design_name', label: 'Mystic Design' },
    { name: 'name', label: 'Mystic Color' },
    { name: 'collection_supplier_name', label: 'Supplier Collection' },
    { name: 'design_supplier_name', label: 'Supplier Design' },
    { name: 'color_supplier_name', label: 'Supplier Color' },
    { name: 'copy', label: ' ' }
  ];

  filteredData: any[];
  filteredTotal: number;
  //searchTerm: string;
  fromRow: number = 1;
  currentPage: number = 1;
  //pageSize: number = 5;
  sortBy: string = 'id';
  selectedRows: any[] = [];
  sortOrder: TdDataTableSortingOrder = TdDataTableSortingOrder.Ascending;
  selectable: boolean = true;
  multipleSelect: boolean = true;

  all_products: Product[];

  constructor(private _dataTableService: TdDataTableService,
    private _dialogService: TdDialogService,
    private _productService: ProductService,
    private _supplierService: SupplierService,
    private _loadingService: TdLoadingService,
    private _settingsService: SettingsService,
    private _viewContainerRef: ViewContainerRef,
    public _exportService: ExportService,
    public _authService: AuthenticationService
  ) { }

  ngOnInit(): void {
    this._loadingService.register('loading');

    this.presetSearchBox();

    this.subscription = this._productService
      .getProducts()
      .subscribe((products: Product[]) => {
        this.all_products = products;

        this.data = this.all_products.slice();
        /*
        this.filteredData = this.data;
        this.filteredTotal = this.data.length;
        this.selectedRows = this.filteredData;
        */
        this.filter();
        this._loadingService.resolve('loading');

      });

    this.allFabricTypes$ = this._productService.getProductTypes();
    this.allSuppliers$ = this._supplierService.getSuppliers();
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  presetSearchBox() {
    if (this._settingsService.getSearchTerm('product')) {
      this._searchBox.value = this._settingsService.getSearchTerm('product');
      this._searchBox.searchClicked();
    }    
  }

  sort(sortEvent: ITdDataTableSortChangeEvent): void {
    this.sortBy = sortEvent.name;
    this.sortOrder = sortEvent.order;
    this.filter();
  }

  search(searchTerm: string): void {
    this._settingsService.setSearchTerm('product', searchTerm);
    //this.searchTerm = searchTerm;
    this.filter();
  }

  page(pagingEvent: IPageChangeEvent): void {
    this.fromRow = pagingEvent.fromRow;
    this.currentPage = pagingEvent.page;
    this._settingsService.setPageSize(pagingEvent.pageSize);
    this.filter();
  }

  fabricFilter(filter) {
    if (filter['value'] == 'all') {
      this.data = this.all_products.slice();
    } else {
      this.data = this.all_products.slice().filter(
        (p: Product) => {
          return p.fabric_type_name == filter['value'];
        }
      );
    }
    this.filter();
  }

  supplierFilter(filter) {
    if (filter['value'] == 'all') {
      this.data = this.all_products.slice();
    } else {
      this.data = this.all_products.slice().filter(
        (p: Product) => {
          return p.supplier_name == filter['value'];
        }
      );
    }
    this.filter();
  }

  filter(): void {
    let newData: any[] = this.data;
    let excludedColumns: string[] = this.columns
      .filter((column: ITdDataTableColumn) => {
        return ((column.filter === undefined && column.hidden === true) ||
          (column.filter !== undefined && column.filter === false));
      }).map((column: ITdDataTableColumn) => {
        return column.name;
      });
    newData = this._dataTableService.filterData(newData, this._settingsService.getSearchTerm('product'), true, excludedColumns);
    this.filteredTotal = newData.length;
    newData = Utils.sortData(newData, this.sortBy, this.sortOrder);
    if (this._settingsService.getPageSize() + '' != 'All') {
      newData = this._dataTableService.pageData(newData, this.fromRow, this.currentPage * this._settingsService.getPageSize());
    }
    this.filteredData = newData;
  }

  openConfirm(): void {
    this._dialogService.openConfirm({
      message: 'Are you sure that you want to delete these items?',
      disableClose: false,
      title: 'Confirm',
    }).afterClosed().subscribe((accept: boolean) => {
      if (accept) {
        this.selectedRows.forEach(
          row => {
            this._productService.deleteProduct(row.id).subscribe(
              response => {
                this.data = this.data.filter(d => { return d.id != response.id });
                this.selectedRows = this.selectedRows.filter(d => { return d.id != response.id });
                this.filter();
              }
            );
          }
        );
      } else {
        // DO SOMETHING ELSE
      }
    });
  }
}



// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/agatextscreens/purchasing/products/products-list/purchasing-products-list.component.ts